import { PageData } from '../../../../_metronic/helpers/utils/types';
import { getIdealImageSize } from '../../../../_metronic/helpers/utils/utils';

export const navbarData: PageData = [
  {
    formId: 'form1',
    heading: 'Navbar Section',
    data: [
      {
        id: 'logo',
        label: 'Company logo',
        info: getIdealImageSize(130, 48),
        type: 'image',
        backgroundColor: 'black'
      },
      {
        id: 'languageButtonText',
        label: 'Text for language button',
        type: 'input',
        hasToggle: true,
        toggleId: 'showLanguageButton',
        toggleLabel: 'On/Off'
      },
      { id: 'donateButtonText', label: 'Donate button text', type: 'input' },
      { id: 'donateButtonLink', label: 'Donate button link', type: 'input' },
      { id: 'signUpButtonText', label: 'Sign up button text', type: 'input' },
      { id: 'signUpButtonLink', label: 'Sign up button link', type: 'input' },
      { id: 'loginButtonText', label: 'Login button text', type: 'input' },
      { id: 'loginButtonLink', label: 'Login button link', type: 'input' }
    ]
  },
  {
    formId: 'formGroup1',
    heading: 'Navbar links',
    data: [
      { id: 'navText', label: 'Navbar link text', type: 'input' },
      { id: 'navLink', label: 'Navbar link URL', type: 'input' }
    ],
    nested: {
      heading: 'Navbar sub-links',
      data: [
        { id: 'subNavText', label: 'Text of child navbar item', type: 'input' },
        { id: 'subNavLink', label: 'Link of child navbar item', type: 'input' }
      ]
    }
  }
];
